import React from 'react';
import { PrimaryButton } from 'components/buttons/primary-button/primary.button';
import { translate, translationKeys } from 'logic/translations/translations.service';

type ButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

export const RateButton: React.FC<ButtonProps> = ({ disabled, onClick }) => {
  return (
    <PrimaryButton onClick={onClick} disabled={disabled}>
      {translate(translationKeys.rateTooltips.buttonSend2)}
    </PrimaryButton>
  );
};
